class VindiWizardLogin {
    constructor() {
        this.init();
    }

    init() {
        this.setupFormSubmission();
        this.setupBackButton();
        this.setupCPFMask();
    }

    setupCPFMask() {
        const cpfInput = document.querySelector('input[name="vindi-login-cpf"]');
        if (cpfInput && typeof IMask !== 'undefined') {
            IMask(cpfInput, { mask: '000.000.000-00' });
        }
    }

    setupFormSubmission() {
        const form = document.getElementById('vindi-login-form');
        if (form) {
            form.addEventListener('submit', (e) => {
                e.preventDefault();
                this.handleLogin();
            });
        }
    }

    setupBackButton() {
        const backButton = document.querySelector('.vindi-wizard-back-btn');
        if (backButton) {
            backButton.addEventListener('click', (e) => {
                e.preventDefault();
                window.location.href = `${window.location.origin}/wp-admin/admin.php?page=vindi-wizard&step=welcome`;
            });
        }
    }

    validateForm() {
        const email = document.querySelector('input[name="vindi-login-email"]').value;
        const cpf = document.querySelector('input[name="vindi-login-cpf"]').value;

        if (!email || !email.includes('@')) {
            alert('Por favor, digite um e-mail válido.');
            return false;
        }

        // Remove formatação do CPF para validar
        const cpfClean = cpf.replace(/\D/g, '');
        if (!cpfClean || cpfClean.length !== 11) {
            alert('Por favor, digite um CPF válido.');
            return false;
        }

        return true;
    }

    async handleLogin() {
        if (!this.validateForm()) {
            return;
        }

        this.setLoadingState(true);

        try {
            const email = document.querySelector('input[name="vindi-login-email"]').value;
            const cpf = document.querySelector('input[name="vindi-login-cpf"]').value.replace(/\D/g, '');

            const response = await this.validateAccount(email, cpf);

            if (response.success) {
                // Salvar dados do usuário validado
                localStorage.setItem('vindi-user-data', JSON.stringify(response.data));
                
                // Redirecionar para próximo passo (token)
                window.location.href = `${window.location.origin}/wp-admin/admin.php?page=vindi-wizard&step=token`;
            } else {
                alert(response.message || 'Erro ao validar conta. Verifique suas credenciais.');
            }
        } catch (error) {
            console.error('Erro no login:', error);
            alert('Erro de conexão. Tente novamente.');
        } finally {
            this.setLoadingState(false);
        }
    }

    async validateAccount(email, cpf) {
        try {
            // Primeiro tentar validar via API do WordPress
            const formData = new FormData();
            formData.append('action', 'vindi_validate_account');
            formData.append('nonce', vindiWizardConfig?.nonce || '');
            formData.append('email', email);
            formData.append('cpf', cpf);

            const response = await fetch(vindiWizardConfig?.ajaxUrl || '/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: formData
            });

            const result = await response.json();
            return result;
        } catch (error) {
            console.error('Erro na validação:', error);
            return {
                success: false,
                message: 'Erro de conexão com o servidor.'
            };
        }
    }

    setLoadingState(loading) {
        const button = document.getElementById('vindi-login-btn');
        const textSpan = button.querySelector('.btn-text');
        const loadingSpan = button.querySelector('.btn-loading');

        if (loading) {
            button.disabled = true;
            textSpan.style.display = 'none';
            loadingSpan.style.display = 'inline';
        } else {
            button.disabled = false;
            textSpan.style.display = 'inline';
            loadingSpan.style.display = 'none';
        }
    }
}

// Inicializar quando o DOM estiver carregado
document.addEventListener('DOMContentLoaded', () => {
    // Verificar se estamos na página de login
    const loginForm = document.getElementById('vindi-login-form');
    if (loginForm) {
        new VindiWizardLogin();
    }
});
